import { ShippingBooking } from '../types/shipping-booking.type';

const BDT = new Intl.NumberFormat('en-IN');

function onPrint() {
    const printView = document.getElementById('print-view');
    if (printView) {
        let printableContent: string = "";
        document.querySelectorAll('.print-section').forEach((element) => {
            printableContent += element.innerHTML;
        });
        printView.innerHTML = printableContent;
    }
    window.print();
}

export function clearPrintView() {
    const printView = document.getElementById('print-view');
    if (printView) {
        printView.innerHTML = "";
    }
}

export function printShippingChallan(booking: Partial<ShippingBooking>, settings?: any) {
    const printView = document.getElementById('print-view');
    if (!printView) {
        window.print();
        return;
    }

    const weight = Math.max(0, Number(booking.weight ?? 5));
    const ratePerKg = Math.max(0, Number(booking.shipment_rate_per_kg ?? 850));
    const shipmentCharge = weight * ratePerKg;
    const warehouseCharge = Math.max(0, Number(booking.warehouse_repackaging_cost ?? 0));
    const transportCharge = Math.max(0, Number(booking.transportation_cost ?? 0));
    const codCharge = Math.max(0, Number(booking.cod_charge ?? 0));
    const totalCost = warehouseCharge + shipmentCharge + transportCharge + codCharge;
    const paid = Math.max(0, Number(booking.paid ?? 0));
    const due = Math.max(0, totalCost - paid);
    const items = booking.items && Array.isArray(booking.items) ? booking.items : [];

    printView.innerHTML = `
        <div class="challan-print-wrapper">
            <div class="challan-header">
                <div class="company-info">
                    <h2>China Hub BD</h2>
                    <p>${settings?.company_address || '151/1/F Ahamednagor, Zonaki Road, Mirpur-1, Dhaka -1216'}</p>
                    <p>Phone: ${settings?.company_phone || '+8801709339369'} | Email: ${settings?.company_email || 'infochinahubbd@gmail.com'}</p>
                </div>
                <div class="challan-title-box">
                    <h3>SHIPPING CHALLAN</h3>
                    <div><strong>Challan #:</strong> ${booking.booking_id || 'N/A'}</div>
                    <div><strong>Date:</strong> ${new Date(booking.created_at || Date.now()).toLocaleDateString()}</div>
                    <div><strong>Status:</strong> ${booking.status || 'Pending'}</div>
                </div>
            </div>

            <div class="challan-meta-grid">
                <div class="meta-item">
                    <strong>Customer Name:</strong>
                    <span>${booking.customer_name || 'N/A'}</span>
                </div>
                <div class="meta-item">
                    <strong>Phone:</strong>
                    <span>${booking.customer_phone || 'N/A'}</span>
                </div>
                <div class="meta-item">
                    <strong>Shipping Mark:</strong>
                    <span>${booking.shipping_mark || 'N/A'}</span>
                </div>
                <div class="meta-item">
                    <strong>Method:</strong>
                    <span>${booking.method || 'Air Shipment'}</span>
                </div>
                <div class="meta-item">
                    <strong>Tracking Number:</strong>
                    <span>${booking.tracking_no || 'N/A'}</span>
                </div>
                <div class="meta-item">
                    <strong>Cartons:</strong>
                    <span>${booking.carton_count || 1}</span>
                </div>
                <div class="meta-item">
                    <strong>Packaging Size:</strong>
                    <span>${booking.packaging_size || 'N/A'}</span>
                </div>
                <div class="meta-item">
                    <strong>Route:</strong>
                    <span>${booking.shipping_route || 'Guangzhou'}</span>
                </div>
            </div>

            ${items.length > 0 ? `
                <table class="challan-table">
                    <thead>
                        <tr>
                            <th style="width: 40px;">#</th>
                            <th>Item Name</th>
                            <th style="width: 100px;">Quantity</th>
                            <th>Category</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${items.map((it, idx) => `
                            <tr>
                                <td>${idx + 1}</td>
                                <td>${it.item_name}</td>
                                <td>${it.quantity}</td>
                                <td>${it.is_special_category ? 'Special (Battery/Liquid/Powder)' : 'General'}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            ` : ''}

            <table class="challan-table">
                <thead>
                    <tr>
                        <th>Subject</th>
                        <th>Details</th>
                        <th class="amount-col">Amount (BDT)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>a) Warehouse / Repackaging</td>
                        <td>Handling &amp; Repackaging Charge</td>
                        <td class="amount-col">${BDT.format(warehouseCharge)}/=</td>
                    </tr>
                    <tr>
                        <td>b) Shipment Cost</td>
                        <td>per kg Shipment ${ratePerKg} x ${weight} kg</td>
                        <td class="amount-col">${BDT.format(shipmentCharge)}/=</td>
                    </tr>
                    <tr>
                        <td>c) Transportation / Courier</td>
                        <td>Local Courier / Transportation</td>
                        <td class="amount-col">${BDT.format(transportCharge)}/=</td>
                    </tr>
                    <tr>
                        <td>d) COD Charge</td>
                        <td>Cash on Delivery Handling</td>
                        <td class="amount-col">${BDT.format(codCharge)}/=</td>
                    </tr>
                </tbody>
            </table>

            <table class="challan-totals-table">
                <tbody>
                    <tr class="total-row">
                        <td>Total Bill:</td>
                        <td class="amount-col">${BDT.format(totalCost)}/=</td>
                    </tr>
                    <tr>
                        <td>Paid Amount:</td>
                        <td class="amount-col">${BDT.format(paid)}/=</td>
                    </tr>
                    <tr class="due-row">
                        <td>Total Due:</td>
                        <td class="amount-col">${BDT.format(due)}/=</td>
                    </tr>
                </tbody>
            </table>

            <div class="challan-footer-signature">
                <div class="sig-block">Customer Signature</div>
                <div class="sig-block">Authorized Signature</div>
            </div>
        </div>
    `;

    setTimeout(() => {
        window.print();
    }, 100);
}

export default onPrint;
